
var __extends = this.__extends || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    __.prototype = b.prototype;
    d.prototype = new __();
};
define('core/buffer_core_array',["require", "exports", './buffer_core'], function(require, exports, buffer_core) {
    // Used to clear segments of an array index.
    var clearMasks = [0xFFFFFF00, 0xFFFF00FF, 0xFF00FFFF, 0x00FFFFFF];

    /**
    * Implementation of BufferCore that is backed by an array of 32-bit ints.
    * Data is stored little endian.
    * Example: Bytes 0 through 3 are present in the first int:
    *  BYTE 3      BYTE 2      BYTE 1      BYTE 0
    * 0000 0000 | 0000 0000 | 0000 0000 | 0000 0000
    */
    var BufferCoreArray = (function (_super) {
        __extends(BufferCoreArray, _super);
        function BufferCoreArray(length) {
            _super.call(this);
            this.length = length;
            this.buff = new Array(Math.ceil(length / 4));

            // Zero-fill the array.
            var bufflen = this.buff.length;
            for (var i = 0; i < bufflen; i++) {
                this.buff[i] = 0;
            }
        }
        BufferCoreArray.isAvailable = function () {
            return true;
        };

        BufferCoreArray.prototype.getLength = function () {
            return this.length;
        };
        BufferCoreArray.prototype.writeUInt8 = function (i, data) {
            data &= 0xFF;

            // Which int? (Equivalent to (i/4)|0)
            var arrIdx = i >> 2;

            // Which offset? (Equivalent to i - arrIdx*4)
            var intIdx = i & 3;
            this.buff[arrIdx] = this.buff[arrIdx] & clearMasks[intIdx];
            this.buff[arrIdx] = this.buff[arrIdx] | (data << (intIdx << 3));
        };
        BufferCoreArray.prototype.readUInt8 = function (i) {
            // Which int?
            var arrIdx = i >> 2;

            // Which offset?
            var intIdx = i & 3;

            // Bring the data we want into the lowest 8 bits, and truncate.
            return (this.buff[arrIdx] >> (intIdx << 3)) & 0xFF;
        };
        BufferCoreArray.prototype.copy = function (start, end) {
            // Stupid unoptimized copy. Later, we could do optimizations when aligned.
            var newBC = new BufferCoreArray(end - start);
            for (var i = start; i < end; i++) {
                newBC.writeUInt8(i - start, this.readUInt8(i));
            }
            return newBC;
        };
        return BufferCoreArray;
    })(buffer_core.BufferCoreCommon);
    exports.BufferCoreArray = BufferCoreArray;

    // Type-check the class.
    var _ = BufferCoreArray;
});
//# sourceMappingURL=buffer_core_array.js.map
;